<ng-template #typesMessageModalFormContent role="document" let-modal>

  <app-page-comp-header #pageHeader
    [showBottomBorder]="false"
    [title]="formTitle"
  >
  </app-page-comp-header>

  <form (ngSubmit)="typesMessageFormSubmitAttempt()" [formGroup]="typesMessageForm" class="tablelist-form" autocomplete="off">
    <div class="modal-body" id="typesMessageFormDetails">

      <div class="mb-3">
        <label class="form-label" for="messageType-field">Message Type</label>

        <input
          autocomplete="no-fill"
          class="form-control"
          [class.is-invalid]="formSubmitted && formData['messageType'].errors"
          data-lpignore="true"
          formControlName="messageType"
          id="messageType-field"
          type="text"
        />

        @if(formSubmitted && formData['messageType'].hasError('required')) {
          <div class="invalid-feedback">A value is required</div>
        } @else if(formSubmitted && formData['messageType'].hasError('maxlength')) {
          <div class="invalid-feedback">Maximum length of {{ messageTypeMaxLength }} characters has been exceeded</div>
        }
      </div>

      <div class="form-check form-switch mb-2">
        <input class="form-check-input" type="checkbox" role="switch" id="singleTemplate-field" formControlName="singleTemplate" />
        <label class="form-check-label" for="singleTemplate-field">Single Template</label>
      </div>

      <div class="form-check form-switch mb-2">
        <input class="form-check-input" type="checkbox" role="switch" id="active-field" formControlName="active" />
        <label class="form-check-label" for="active-field">Active</label>
      </div>

      <div class="form-check form-switch mb-3">
        <input class="form-check-input" type="checkbox" role="switch" id="allowDefaultMessage-field" formControlName="allowDefaultMessage" (change)="onAllowDefaultMessageChanged()" />
        <label class="form-check-label" for="allowDefaultMessage-field">Allow Default</label>
        <div class="form-text">Wording held here is used when a company has no template of its own for this message type.</div>
      </div>

      @if(allowDefaultMessage) {
        <div class="mb-3">
          <label class="form-label" for="defaultDeliveryTypes-field">Default Sent By</label>

          <select
            class="form-select"
            [class.is-invalid]="formSubmitted && formData['defaultDeliveryTypes'].errors"
            formControlName="defaultDeliveryTypes"
            id="defaultDeliveryTypes-field"
          >
            <option [ngValue]="null">Please select...</option>

            @for(deliveryType of deliveryTypes; track deliveryType.id) {
              <option [ngValue]="deliveryType.id">{{ deliveryType.description }}</option>
            }
          </select>

          @if(formSubmitted && formData['defaultDeliveryTypes'].hasError('required')) {
            <div class="invalid-feedback">A value is required</div>
          }
        </div>

        @if(showSubject) {
          <div class="mb-3">
            <label class="form-label" for="defaultSubject-field">Default Subject</label>

            <input
              autocomplete="no-fill"
              class="form-control"
              [class.is-invalid]="formSubmitted && formData['defaultSubject'].errors"
              data-lpignore="true"
              formControlName="defaultSubject"
              id="defaultSubject-field"
              [maxlength]="subjectMaxLength"
              type="text"
            />

            @if(formSubmitted && formData['defaultSubject'].hasError('maxlength')) {
              <div class="invalid-feedback">Maximum length of {{ subjectMaxLength }} characters has been exceeded</div>
            }
          </div>
        }

        <app-customise-message
          footerText="Used when a company has no template of its own for this message type"
          idPrefix="defaultmessage"
          label="Default message"
          requiredText="A default message is required"
          [canEdit]="true"
          [defaultText]="originalMessage"
          [expanded]="true"
          [replacements]="replacements"
          [title]="customiseTitle"
          [(value)]="defaultMessage"
        ></app-customise-message>
      }

    </div>

    <div class="modal-footer">
      <div class="col-12">
        <div class="row">
          <div class="col-12">
            <div class="hstack gap-2 justify-content-end">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="typesMessageFormCancel()">Close</button>
              <!--RBW_20261022 - Only disabled while saving. Disabling it on validity left no way to find out WHY it was
                                 disabled: clicking now marks the form submitted, which is what reveals the errors.-->
              <button type="submit" class="btn btn-success" id="add-btn-types-message" [disabled]="saving">{{ saving ? 'Saving...' : 'Submit' }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

  </form>

</ng-template>
